import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import classnames from 'classnames'
import { indexMap } from '@helpers'
import './ComboBox.module.scss'

const ComboBox = ({
  options,
  change,
  selectedValue,
  label,
  field,
  form,
  defaultValue
}) => {
  const formik = {}

  if (field && form) {
    const touched = R.propOr({}, 'touched', form)
    const errors = R.propOr({}, 'errors', form)

    formik.name = R.prop('name', field)
    formik.error = errors[formik.name]
    formik.touch = touched[formik.name]
    formik.showError = formik.error && formik.touch
  }

  return (
    <Fragment>
      {label && <label styleName='label'>{label}</label>}
      <select
        styleName={classnames('combo',
          {'error': formik.showError},
          {'accepted': !formik.showError && formik.touch}
        )}
        onChange={change}
        value={selectedValue}
      >
        {defaultValue && <option selected='selected'>{defaultValue}</option>}
        {indexMap((option, index) => (
          <option key={R.prop('value', option) || index} value={R.prop('value', option) || R.prop('text', option)}>
            {R.prop('text', option)}
          </option>
        ), options)}
      </select>
      {formik.showError && <span styleName='warning'>{formik.error}</span>}
    </Fragment>
  )
}

ComboBox.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.string,
  change: PropTypes.func,
  label: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.object
}

ComboBox.defaultProps = {
  options: [],
  selectedValue: '',
  label: '',
  change: () => {}
}

export default ComboBox



// WEBPACK FOOTER //
// ./src/components/Form/ComboBox/ComboBox.js